import { styled } from '../../base';

export const StyledSettingsPage = styled('div')(({ theme }) => ({
    padding: theme.spacing(3),
    alignItems: 'center',
    marginBottom: theme.spacing(4),
}));
